
<div class="mmc_banner p-5" [class]="computedCssClass">
  <div class="mmc_banner-top flex-row align--center mb-4">
    <i class="material-icons pw-ico-color" *ngIf="(data?.Icon && data.Icon.length > 0) || sanitizedHeaderIcon != ''" [innerHtml]="sanitizedHeaderIcon"></i>
    <h2
      [class.heading-M]="callOutSize"
      [class.heading-S]="!callOutSize"
      *ngIf="hasTitleContent"
      [innerHTML]="sanitizedTitle"
      class="pw-txt-h2 pw-text-bold"
    ></h2>
  </div>
  <p class="pw-txt-p mb-2" *ngIf="(data?.Description && data.Description.length > 0) || sanitizedDescription != ''" [innerHTML]="sanitizedDescription"></p>
  <h4 class="pw-txt-h4 pw-text-bold mb-2" *ngIf="(data?.BookingRefMessage && data.BookingRefMessage.length > 0) || sanitizedBookingRefMessage != ''" [innerHTML]="sanitizedBookingRefMessage"></h4>
  <p class="pw-txt-p mb-2" *ngIf="(data?.ContactInfo && data.ContactInfo.length > 0) || sanitizedContactInfo != ''" [innerHTML]="sanitizedContactInfo"></p>
  <div class="mmc_flex__item--vcenter" [ngClass]="{ 'announcement-button-default': isButtonDefault }">
    <ng-content></ng-content>
  </div>
</div>
